// import React, { useState, useEffect, useMemo } from 'react';
// import { db, auth } from '../firebase/config';
// import { 
//   collection, 
//   getDocs, 
//   doc, 
//   updateDoc, 
//   Timestamp,
//   query,
//   orderBy,
//   getDoc,
//   setDoc,
//   arrayUnion,
//   where
// } from 'firebase/firestore';
// import { signOut } from 'firebase/auth';
// import './Dashboard.css';
// import toast, { Toaster } from 'react-hot-toast';

// const AdminDashboard = () => {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [filterType, setFilterType] = useState('all');
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [showUserModal, setShowUserModal] = useState(false);
//   const [showPlanModal, setShowPlanModal] = useState(false);
//   const [selectedUserId, setSelectedUserId] = useState(null);
//   const [customDate, setCustomDate] = useState('');
//   const [customTime, setCustomTime] = useState('23:59');
//   const [activeCollection, setActiveCollection] = useState('users');
//   const [collections, setCollections] = useState(['users']);

//   // Fetch collections from Firestore
//   useEffect(() => {
//     fetchCollections();
//     fetchUsers();
//   }, [activeCollection]);

//   const fetchCollections = async () => {
//     try {
//       const snapshot = await getDocs(collection(db, activeCollection));
//       // This is just to verify collection exists
//       // In real app, you might want to fetch all collection names differently
//     } catch (error) {
//       console.error('Error fetching collections:', error);
//     }
//   };

//   const fetchUsers = async () => {
//     try {
//       setLoading(true);
//       toast.loading(`Loading ${activeCollection}...`, { id: 'loading' });
      
//       const collectionRef = collection(db, activeCollection);
//       let q;
      
//       if (activeCollection === 'users') {
//         q = query(collectionRef, orderBy('createdAt', 'desc'));
//       } else {
//         q = query(collectionRef);
//       }
      
//       const snapshot = await getDocs(q);
      
//       const dataList = [];
      
//       for (const docSnap of snapshot.docs) {
//         const data = docSnap.data();
//         const docId = docSnap.id;
        
//         // Calculate premium status if it's users collection
//         let premiumStatus = {};
//         if (activeCollection === 'users' && data.premiumUntil) {
//           premiumStatus = {
//             isPremiumActive: checkPremiumActive(data.premiumUntil),
//             daysLeftInPremium: calculateDaysLeftInPremium(data.premiumUntil),
//             premiumEndDate: formatFirestoreDate(data.premiumUntil)
//           };
//         }
        
//         // Get history if it's users collection
//         let history = [];
//         if (activeCollection === 'users') {
//           const historyRef = doc(db, 'user_activation_history', docId);
//           const historySnap = await getDoc(historyRef);
//           history = historySnap.exists() ? historySnap.data().history || [] : [];
//         }
        
//         dataList.push({
//           id: docId,
//           ...data,
//           ...premiumStatus,
//           activationHistory: history,
//           // Format dates for display
//           formattedCreatedAt: formatFirestoreDate(data.createdAt),
//           formattedUpdatedAt: formatFirestoreDate(data.updatedAt),
//           formattedLastLogin: formatFirestoreDate(data.lastLogin),
//           formattedLastPlanActivation: formatFirestoreDate(data.lastPlanActivation),
//           formattedPremiumUntil: formatFirestoreDate(data.premiumUntil)
//         });
//       }
      
//       setUsers(dataList);
//       toast.success(`Loaded ${dataList.length} ${activeCollection}`, { id: 'loading' });
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching data:', error);
//       toast.error(`Failed to load ${activeCollection}: ${error.message}`);
//       setLoading(false);
//     }
//   };

//   // Check if premium is active
//   const checkPremiumActive = (premiumUntil) => {
//     if (!premiumUntil) return false;
//     try {
//       const premiumDate = premiumUntil.toDate ? premiumUntil.toDate() : new Date(premiumUntil);
//       return premiumDate > new Date();
//     } catch (e) {
//       return false;
//     }
//   };

//   // Calculate days left in premium
//   const calculateDaysLeftInPremium = (premiumUntil) => {
//     if (!premiumUntil) return 0;
//     try {
//       const endDate = premiumUntil.toDate ? premiumUntil.toDate() : new Date(premiumUntil);
//       const today = new Date();
//       const diffTime = endDate - today;
//       const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//       return diffDays > 0 ? diffDays : 0;
//     } catch (e) {
//       return 0;
//     }
//   };

//   // Format Firestore timestamp to date
//   const formatFirestoreDate = (timestamp) => {
//     if (!timestamp) return 'N/A';
//     try {
//       const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
//       return date.toLocaleString('en-US', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit'
//       });
//     } catch (e) {
//       return 'Invalid Date';
//     }
//   };

//   // Open plan activation modal
//   const openPlanModal = (userId) => {
//     setSelectedUserId(userId);
//     // Set default date to tomorrow
//     const tomorrow = new Date();
//     tomorrow.setDate(tomorrow.getDate() + 1);
//     setCustomDate(tomorrow.toISOString().split('T')[0]);
//     setCustomTime('23:59');
//     setShowPlanModal(true);
//   };

//   // Activate custom plan
//   const activateCustomPlan = async () => {
//     try {
//       if (!selectedUserId || !customDate) {
//         toast.error('Please select a date');
//         return;
//       }

//       toast.loading('Activating custom plan...', { id: 'activate' });

//       const userRef = doc(db, 'users', selectedUserId);
//       const userSnap = await getDoc(userRef);
//       const userData = userSnap.data();

//       // Create custom expiry date
//       const expiryDate = new Date(`${customDate}T${customTime}`);
      
//       // Calculate days difference
//       const today = new Date();
//       const diffTime = expiryDate - today;
//       const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//       const diffMonths = Math.floor(diffDays / 30);
//       const remainingDays = diffDays % 30;

//       let durationText = '';
//       if (diffMonths > 0) {
//         durationText = `${diffMonths} month${diffMonths > 1 ? 's' : ''}`;
//         if (remainingDays > 0) {
//           durationText += ` ${remainingDays} day${remainingDays > 1 ? 's' : ''}`;
//         }
//       } else {
//         durationText = `${diffDays} day${diffDays > 1 ? 's' : ''}`;
//       }

//       // Update user document
//       await updateDoc(userRef, {
//         planType: 'premium',
//         activePlan: 'custom_premium',
//         planName: `Custom Premium (${durationText})`,
//         premiumUntil: Timestamp.fromDate(expiryDate),
//         updatedAt: Timestamp.now(),
//         lastPlanActivation: Timestamp.now(),
//         customPlanActivated: true,
//         customPlanDuration: durationText,
//         customPlanExpiry: expiryDate.toISOString()
//       });

//       // Save to activation history
//       const historyRef = doc(db, 'user_activation_history', selectedUserId);
//       const historyEntry = {
//         planId: 'custom_premium',
//         planName: 'Custom Premium Plan',
//         planType: 'premium',
//         activatedAt: Timestamp.now(),
//         expiresAt: Timestamp.fromDate(expiryDate),
//         duration: durationText,
//         activatedBy: 'admin',
//         userEmail: userData.email,
//         customActivation: true,
//         expiryDate: expiryDate.toISOString(),
//         totalDays: diffDays
//       };

//       if (!(await getDoc(historyRef)).exists()) {
//         await setDoc(historyRef, { history: [historyEntry] });
//       } else {
//         await updateDoc(historyRef, {
//           history: arrayUnion(historyEntry)
//         });
//       }

//       toast.success(`Custom premium plan activated until ${formatFirestoreDate(Timestamp.fromDate(expiryDate))}`, {
//         id: 'activate',
//         duration: 5000
//       });

//       // Close modal and refresh
//       setShowPlanModal(false);
//       setSelectedUserId(null);
//       fetchUsers();

//     } catch (error) {
//       console.error('Error activating custom plan:', error);
//       toast.error(`Failed to activate plan: ${error.message}`, {
//         id: 'activate'
//       });
//     }
//   };

//   // Deactivate premium
//   const deactivatePremium = async (userId) => {
//     try {
//       toast.loading('Deactivating premium...', { id: 'deactivate' });
      
//       const userRef = doc(db, 'users', userId);
//       const userSnap = await getDoc(userRef);
//       const userData = userSnap.data();
      
//       await updateDoc(userRef, {
//         planType: 'free',
//         activePlan: 'free',
//         planName: 'Free',
//         premiumUntil: null,
//         updatedAt: Timestamp.now(),
//         premiumDeactivatedAt: Timestamp.now(),
//         customPlanActivated: false,
//         customPlanDuration: null,
//         customPlanExpiry: null
//       });

//       // Add to history
//       const historyRef = doc(db, 'user_activation_history', userId);
//       const historyEntry = {
//         action: 'deactivate',
//         previousPlan: userData.activePlan || 'premium',
//         deactivatedAt: Timestamp.now(),
//         deactivatedBy: 'admin',
//         userEmail: userData.email,
//         reason: 'Admin deactivated'
//       };

//       if ((await getDoc(historyRef)).exists()) {
//         await updateDoc(historyRef, {
//           history: arrayUnion(historyEntry)
//         });
//       }

//       toast.success('Premium deactivated successfully!', {
//         id: 'deactivate',
//         duration: 3000
//       });
      
//       fetchUsers();
//     } catch (error) {
//       console.error('Error deactivating premium:', error);
//       toast.error(`Error deactivating premium: ${error.message}`, {
//         id: 'deactivate'
//       });
//     }
//   };

//   // View user details
//   const viewUserDetails = (user) => {
//     setSelectedUser(user);
//     setShowUserModal(true);
//   };

//   // Logout function
//   const handleLogout = async () => {
//     try {
//       await signOut(auth);
//       toast.success('Logged out successfully');
//       window.location.href = '/login';
//     } catch (error) {
//       toast.error('Error logging out');
//     }
//   };

//   // Filter users based on search
//   const filteredUsers = useMemo(() => {
//     return users.filter(user => {
//       if (!searchTerm) return true;
      
//       // Search in all string fields
//       const searchLower = searchTerm.toLowerCase();
      
//       return (
//         (user.email && user.email.toLowerCase().includes(searchLower)) ||
//         (user.name && user.name.toLowerCase().includes(searchLower)) ||
//         (user.uid && user.uid.toLowerCase().includes(searchLower)) ||
//         (user.phone && user.phone.includes(searchTerm)) ||
//         (user.city && user.city.toLowerCase().includes(searchLower)) ||
//         (user.country && user.country.toLowerCase().includes(searchLower))
//       );
//     });
//   }, [users, searchTerm]);

//   // Get user stats
//   const userStats = useMemo(() => {
//     const total = users.length;
//     const premium = users.filter(u => u.planType === 'premium' && u.isPremiumActive).length;
//     const free = users.filter(u => u.planType === 'free').length;
//     const active = users.filter(u => u.status === 'active').length;
    
//     return { total, premium, free, active };
//   }, [users]);

//   if (loading) {
//     return (
//       <div className="admin-container">
//         <div className="loading-spinner">
//           <div className="spinner"></div>
//           <p>Loading {activeCollection}...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="admin-container">
//       <Toaster 
//         position="top-right"
//         toastOptions={{
//           duration: 4000,
//           style: {
//             background: '#363636',
//             color: '#fff',
//             borderRadius: '10px',
//             padding: '16px'
//           },
//         }}
//       />
      
//       {/* Header */}
//       <header className="admin-header">
//         <div className="header-left">
//           <h1>🚀 Admin Dashboard</h1>
//           <div className="collection-selector">
//             <select 
//               value={activeCollection}
//               onChange={(e) => setActiveCollection(e.target.value)}
//               className="collection-select"
//             >
//               <option value="users">👥 Users</option>
//               {/* Add more collections as needed */}
//             </select>
//           </div>
//         </div>
        
//         <div className="header-right">
//           <div className="user-info">
//             <span className="admin-email">{auth.currentUser?.email}</span>
//             <button onClick={handleLogout} className="btn-logout">
//               🔓 Logout
//             </button>
//           </div>
//         </div>
//       </header>

//       {/* Stats Cards */}
//       <div className="stats-grid">
//         <div className="stat-card">
//           <div className="stat-icon">👥</div>
//           <div className="stat-content">
//             <h3>{userStats.total}</h3>
//             <p>Total Users</p>
//           </div>
//         </div>
        
//         <div className="stat-card premium">
//           <div className="stat-icon">⭐</div>
//           <div className="stat-content">
//             <h3>{userStats.premium}</h3>
//             <p>Active Premium</p>
//           </div>
//         </div>
        
//         <div className="stat-card free">
//           <div className="stat-icon">🎯</div>
//           <div className="stat-content">
//             <h3>{userStats.free}</h3>
//             <p>Free Users</p>
//           </div>
//         </div>
        
//         <div className="stat-card active">
//           <div className="stat-icon">✅</div>
//           <div className="stat-content">
//             <h3>{userStats.active}</h3>
//             <p>Active Users</p>
//           </div>
//         </div>
//       </div>

//       {/* Search and Filter */}
//       <div className="search-section">
//         <div className="search-box">
//           <input
//             type="text"
//             placeholder={`Search ${activeCollection}...`}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             className="search-input"
//           />
//           <button className="btn-search">🔍</button>
//         </div>
        
//         <div className="filter-tabs">
//           <button 
//             className={`filter-tab ${filterType === 'all' ? 'active' : ''}`}
//             onClick={() => setFilterType('all')}
//           >
//             All
//           </button>
//           <button 
//             className={`filter-tab ${filterType === 'premium' ? 'active' : ''}`}
//             onClick={() => setFilterType('premium')}
//           >
//             Premium
//           </button>
//           <button 
//             className={`filter-tab ${filterType === 'free' ? 'active' : ''}`}
//             onClick={() => setFilterType('free')}
//           >
//             Free
//           </button>
//           <button 
//             className={`filter-tab ${filterType === 'active' ? 'active' : ''}`}
//             onClick={() => setFilterType('active')}
//           >
//             Active
//           </button>
//         </div>
//       </div>

//       {/* Users Table */}
//       <div className="table-container">
//         <div className="table-wrapper">
//           <table className="data-table">
//             <thead>
//               <tr>
//                 <th>#</th>
//                 <th>User Info</th>
//                 <th>Plan Status</th>
//                 <th>Location</th>
//                 <th>Device</th>
//                 <th>Last Login</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {filteredUsers.length === 0 ? (
//                 <tr>
//                   <td colSpan="7" className="no-data">
//                     No {activeCollection} found
//                   </td>
//                 </tr>
//               ) : (
//                 filteredUsers.map((user, index) => (
//                   <tr key={user.id}>
//                     <td>{index + 1}</td>
//                     <td className="user-cell">
//                       <div className="user-avatar">
//                         {user.name?.charAt(0) || 'U'}
//                       </div>
//                       <div className="user-details">
//                         <div className="user-name">{user.name || 'No Name'}</div>
//                         <div className="user-email">{user.email || 'No Email'}</div>
//                         <div className="user-meta">
//                           <span className="user-id">ID: {user.uid || user.id}</span>
//                           <span className="user-phone">{user.phone || 'No Phone'}</span>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="plan-status">
//                         <span className={`plan-badge ${user.planType === 'premium' ? 'premium' : 'free'}`}>
//                           {user.planType === 'premium' ? '⭐ Premium' : '🎯 Free'}
//                         </span>
//                         {user.premiumUntil && (
//                           <div className="plan-expiry">
//                             <small>Expires: {user.formattedPremiumUntil}</small>
//                             {user.daysLeftInPremium > 0 && (
//                               <small className="days-left">({user.daysLeftInPremium} days left)</small>
//                             )}
//                           </div>
//                         )}
//                       </div>
//                     </td>
//                     <td>
//                       <div className="location-info">
//                         <div className="city">{user.city || 'N/A'}</div>
//                         <div className="country">{user.country || 'N/A'}</div>
//                       </div>
//                     </td>
//                     <td>
//                       <div className="device-info">
//                         <span className={`device-badge ${user.deviceType}`}>
//                           {user.deviceType || 'Unknown'}
//                         </span>
//                         {user.fcmToken && (
//                           <small className="fcm-status">FCM Active</small>
//                         )}
//                       </div>
//                     </td>
//                     <td>
//                       <div className="login-info">
//                         {user.formattedLastLogin}
//                         {user.emailVerified && (
//                           <span className="verified-badge">✓ Verified</span>
//                         )}
//                       </div>
//                     </td>
//                     <td className="actions-cell">
//                       <div className="action-buttons">
//                         <button 
//                           className="btn-action view"
//                           onClick={() => viewUserDetails(user)}
//                           title="View Details"
//                         >
//                           👁️
//                         </button>
                        
//                         {user.planType === 'premium' ? (
//                           <button 
//                             className="btn-action deactivate"
//                             onClick={() => deactivatePremium(user.id)}
//                             title="Deactivate Premium"
//                           >
//                             ❌
//                           </button>
//                         ) : (
//                           <button 
//                             className="btn-action activate"
//                             onClick={() => openPlanModal(user.id)}
//                             title="Activate Premium"
//                           >
//                             ⭐
//                           </button>
//                         )}
                        
//                         <button 
//                           className="btn-action refresh"
//                           onClick={fetchUsers}
//                           title="Refresh"
//                         >
//                           🔄
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>

//       {/* Plan Activation Modal */}
//       {showPlanModal && (
//         <div className="modal-overlay">
//           <div className="modal">
//             <div className="modal-header">
//               <h3>Activate Custom Premium Plan</h3>
//               <button 
//                 className="modal-close"
//                 onClick={() => setShowPlanModal(false)}
//               >
//                 ✕
//               </button>
//             </div>
            
//             <div className="modal-body">
//               <div className="form-group">
//                 <label>Select Expiry Date</label>
//                 <input
//                   type="date"
//                   value={customDate}
//                   onChange={(e) => setCustomDate(e.target.value)}
//                   className="form-input"
//                   min={new Date().toISOString().split('T')[0]}
//                 />
//               </div>
              
//               <div className="form-group">
//                 <label>Select Expiry Time</label>
//                 <input
//                   type="time"
//                   value={customTime}
//                   onChange={(e) => setCustomTime(e.target.value)}
//                   className="form-input"
//                 />
//               </div>
              
//               {customDate && (
//                 <div className="plan-preview">
//                   <h4>Plan Details:</h4>
//                   <div className="preview-item">
//                     <span>Plan Type:</span>
//                     <strong>Custom Premium</strong>
//                   </div>
//                   <div className="preview-item">
//                     <span>Expiry:</span>
//                     <strong>{new Date(`${customDate}T${customTime}`).toLocaleString()}</strong>
//                   </div>
//                   <div className="preview-item">
//                     <span>Duration:</span>
//                     <strong>
//                       {(() => {
//                         const expiryDate = new Date(`${customDate}T${customTime}`);
//                         const today = new Date();
//                         const diffDays = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
//                         const months = Math.floor(diffDays / 30);
//                         const days = diffDays % 30;
                        
//                         if (months > 0) {
//                           return `${months} month${months > 1 ? 's' : ''} ${days > 0 ? `${days} day${days > 1 ? 's' : ''}` : ''}`;
//                         }
//                         return `${diffDays} day${diffDays > 1 ? 's' : ''}`;
//                       })()}
//                     </strong>
//                   </div>
//                 </div>
//               )}
//             </div>
            
//             <div className="modal-footer">
//               <button 
//                 className="btn btn-secondary"
//                 onClick={() => setShowPlanModal(false)}
//               >
//                 Cancel
//               </button>
//               <button 
//                 className="btn btn-primary"
//                 onClick={activateCustomPlan}
//                 disabled={!customDate}
//               >
//                 ✅ Activate Custom Plan
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* User Details Modal */}
//       {showUserModal && selectedUser && (
//         <div className="modal-overlay">
//           <div className="modal user-modal">
//             <div className="modal-header">
//               <h3>User Details</h3>
//               <button 
//                 className="modal-close"
//                 onClick={() => setShowUserModal(false)}
//               >
//                 ✕
//               </button>
//             </div>
            
//             <div className="modal-body">
//               {/* User Profile Section */}
//               <div className="user-profile-section">
//                 <div className="profile-avatar-large">
//                   {selectedUser.name?.charAt(0) || 'U'}
//                 </div>
//                 <div className="profile-info">
//                   <h4>{selectedUser.name || 'No Name'}</h4>
//                   <p className="profile-email">{selectedUser.email || 'No Email'}</p>
//                   <div className="profile-meta">
//                     <span className="meta-badge uid">ID: {selectedUser.uid || selectedUser.id}</span>
//                     <span className="meta-badge phone">📱 {selectedUser.phone || 'No Phone'}</span>
//                     <span className={`meta-badge ${selectedUser.status}`}>
//                       {selectedUser.status || 'unknown'}
//                     </span>
//                   </div>
//                 </div>
//               </div>

//               {/* User Details Grid */}
//               <div className="details-grid">
//                 {/* Account Details */}
//                 <div className="detail-section">
//                   <h5>Account Details</h5>
//                   <div className="detail-row">
//                     <span>Account Type:</span>
//                     <strong>{selectedUser.accountType || 'user'}</strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>User Type:</span>
//                     <strong>{selectedUser.userType || 'regular'}</strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Role:</span>
//                     <strong>{selectedUser.role || 'user'}</strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Email Verified:</span>
//                     <strong className={selectedUser.emailVerified ? 'verified' : 'not-verified'}>
//                       {selectedUser.emailVerified ? '✅ Yes' : '❌ No'}
//                     </strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Profile Complete:</span>
//                     <strong className={selectedUser.profileComplete ? 'yes' : 'no'}>
//                       {selectedUser.profileComplete ? '✅ Yes' : '❌ No'}
//                     </strong>
//                   </div>
//                 </div>

//                 {/* Plan Details */}
//                 <div className="detail-section">
//                   <h5>Plan Details</h5>
//                   <div className="detail-row">
//                     <span>Current Plan:</span>
//                     <strong className={`plan-tag ${selectedUser.planType}`}>
//                       {selectedUser.planName || selectedUser.planType}
//                     </strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Plan Type:</span>
//                     <strong>{selectedUser.planType || 'free'}</strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Active Plan:</span>
//                     <strong>{selectedUser.activePlan || 'free'}</strong>
//                   </div>
//                   {selectedUser.premiumUntil && (
//                     <>
//                       <div className="detail-row">
//                         <span>Premium Until:</span>
//                         <strong>{selectedUser.formattedPremiumUntil}</strong>
//                       </div>
//                       {selectedUser.daysLeftInPremium > 0 && (
//                         <div className="detail-row">
//                           <span>Days Left:</span>
//                           <strong className="days-left">{selectedUser.daysLeftInPremium} days</strong>
//                         </div>
//                       )}
//                     </>
//                   )}
//                 </div>

//                 {/* Location & Device */}
//                 <div className="detail-section">
//                   <h5>Location & Device</h5>
//                   <div className="detail-row">
//                     <span>City:</span>
//                     <strong>{selectedUser.city || 'N/A'}</strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Country:</span>
//                     <strong>{selectedUser.country || 'N/A'}</strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Device Type:</span>
//                     <strong className={`device ${selectedUser.deviceType}`}>
//                       {selectedUser.deviceType || 'Unknown'}
//                     </strong>
//                   </div>
//                   {selectedUser.fcmToken && (
//                     <div className="detail-row">
//                       <span>FCM Token:</span>
//                       <small className="fcm-token">{selectedUser.fcmToken.substring(0, 30)}...</small>
//                     </div>
//                   )}
//                 </div>

//                 {/* Timestamps */}
//                 <div className="detail-section">
//                   <h5>Timestamps</h5>
//                   <div className="detail-row">
//                     <span>Created At:</span>
//                     <strong>{selectedUser.formattedCreatedAt}</strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Last Updated:</span>
//                     <strong>{selectedUser.formattedUpdatedAt}</strong>
//                   </div>
//                   <div className="detail-row">
//                     <span>Last Login:</span>
//                     <strong>{selectedUser.formattedLastLogin}</strong>
//                   </div>
//                   {selectedUser.lastPlanActivation && (
//                     <div className="detail-row">
//                       <span>Last Plan Activation:</span>
//                       <strong>{selectedUser.formattedLastPlanActivation}</strong>
//                     </div>
//                   )}
//                   {selectedUser.premiumActivatedAt && (
//                     <div className="detail-row">
//                       <span>Premium Activated At:</span>
//                       <strong>{formatFirestoreDate(selectedUser.premiumActivatedAt)}</strong>
//                     </div>
//                   )}
//                   {selectedUser.premiumDeactivatedAt && (
//                     <div className="detail-row">
//                       <span>Premium Deactivated At:</span>
//                       <strong>{formatFirestoreDate(selectedUser.premiumDeactivatedAt)}</strong>
//                     </div>
//                   )}
//                 </div>
//               </div>

//               {/* Activation History */}
//               {selectedUser.activationHistory && selectedUser.activationHistory.length > 0 && (
//                 <div className="history-section">
//                   <h5>Activation History ({selectedUser.activationHistory.length})</h5>
//                   <div className="history-list">
//                     {selectedUser.activationHistory.slice(0, 10).map((entry, idx) => (
//                       <div key={idx} className="history-item">
//                         <div className="history-plan">{entry.planName || entry.action || 'Plan Change'}</div>
//                         <div className="history-date">
//                           {entry.activatedAt ? formatFirestoreDate(entry.activatedAt) : 
//                            entry.deactivatedAt ? formatFirestoreDate(entry.deactivatedAt) : 'N/A'}
//                         </div>
//                         <div className="history-duration">{entry.duration || 'N/A'}</div>
//                         <div className="history-by">{entry.activatedBy || entry.deactivatedBy || 'Admin'}</div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               )}
//             </div>
            
//             <div className="modal-footer">
//               <button 
//                 className="btn btn-secondary"
//                 onClick={() => setShowUserModal(false)}
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Footer Actions */}
//       <div className="footer-actions">
//         <button onClick={fetchUsers} className="btn-refresh">
//           🔄 Refresh Data
//         </button>
//         <div className="stats-info">
//           Showing {filteredUsers.length} of {users.length} {activeCollection}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AdminDashboard;



import React, { useState, useEffect, useMemo } from 'react';
import { db, auth } from '../firebase/config';
import { 
  collection, 
  getDocs, 
  doc, 
  updateDoc, 
  Timestamp,
  query,
  orderBy,
  getDoc,
  setDoc,
  arrayUnion,
  where
} from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import './Dashboard.css';
import toast, { Toaster } from 'react-hot-toast';

const AdminDashboard = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [selectedUser, setSelectedUser] = useState(null);
  const [showUserModal, setShowUserModal] = useState(false);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [customDate, setCustomDate] = useState('');
  const [customTime, setCustomTime] = useState('23:59');
  const [activeCollection, setActiveCollection] = useState('users');
  const [collections, setCollections] = useState(['users']);

  // State for copying FCM token
  const [copiedToken, setCopiedToken] = useState(null);

  // Fetch collections from Firestore
  useEffect(() => {
    fetchCollections();
    fetchUsers();
  }, [activeCollection]);

  const fetchCollections = async () => {
    try {
      const snapshot = await getDocs(collection(db, activeCollection));
      // This is just to verify collection exists
    } catch (error) {
      console.error('Error fetching collections:', error);
    }
  };

  const fetchUsers = async () => {
    try {
      setLoading(true);
      toast.loading(`Loading ${activeCollection}...`, { id: 'loading' });
      
      const collectionRef = collection(db, activeCollection);
      let q;
      
      if (activeCollection === 'users') {
        q = query(collectionRef, orderBy('createdAt', 'desc'));
      } else {
        q = query(collectionRef);
      }
      
      const snapshot = await getDocs(q);
      
      const dataList = [];
      
      for (const docSnap of snapshot.docs) {
        const data = docSnap.data();
        const docId = docSnap.id;
        
        // Calculate premium status if it's users collection
        let premiumStatus = {};
        if (activeCollection === 'users' && data.premiumUntil) {
          premiumStatus = {
            isPremiumActive: checkPremiumActive(data.premiumUntil),
            daysLeftInPremium: calculateDaysLeftInPremium(data.premiumUntil),
            premiumEndDate: formatFirestoreDate(data.premiumUntil)
          };
        }
        
        // Get history from user document itself (not separate collection)
        let history = [];
        if (activeCollection === 'users' && data.activationHistory) {
          history = data.activationHistory;
        }
        
        dataList.push({
          id: docId,
          ...data,
          ...premiumStatus,
          activationHistory: history,
          // Format dates for display
          formattedCreatedAt: formatFirestoreDate(data.createdAt),
          formattedUpdatedAt: formatFirestoreDate(data.updatedAt),
          formattedLastLogin: formatFirestoreDate(data.lastLogin),
          formattedLastPlanActivation: formatFirestoreDate(data.lastPlanActivation),
          formattedPremiumUntil: formatFirestoreDate(data.premiumUntil)
        });
      }
      
      setUsers(dataList);
      toast.success(`Loaded ${dataList.length} ${activeCollection}`, { id: 'loading' });
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error(`Failed to load ${activeCollection}: ${error.message}`);
      setLoading(false);
    }
  };

  // Check if premium is active
  const checkPremiumActive = (premiumUntil) => {
    if (!premiumUntil) return false;
    try {
      const premiumDate = premiumUntil.toDate ? premiumUntil.toDate() : new Date(premiumUntil);
      return premiumDate > new Date();
    } catch (e) {
      return false;
    }
  };

  // Calculate days left in premium
  const calculateDaysLeftInPremium = (premiumUntil) => {
    if (!premiumUntil) return 0;
    try {
      const endDate = premiumUntil.toDate ? premiumUntil.toDate() : new Date(premiumUntil);
      const today = new Date();
      const diffTime = endDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays > 0 ? diffDays : 0;
    } catch (e) {
      return 0;
    }
  };

  // Format Firestore timestamp to date
  const formatFirestoreDate = (timestamp) => {
    if (!timestamp) return 'N/A';
    try {
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (e) {
      return 'Invalid Date';
    }
  };

  // Open plan activation modal
  const openPlanModal = (userId) => {
    setSelectedUserId(userId);
    const user = users.find(u => u.id === userId);
    if (user && user.premiumUntil) {
      const premiumDate = user.premiumUntil.toDate ? user.premiumUntil.toDate() : new Date(user.premiumUntil);
      setCustomDate(premiumDate.toISOString().split('T')[0]);
      setCustomTime(premiumDate.toTimeString().split(' ')[0].substring(0, 5));
    } else {
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      setCustomDate(tomorrow.toISOString().split('T')[0]);
      setCustomTime('23:59');
    }
    setShowPlanModal(true);
  };

  // Copy FCM token to clipboard
  const copyFCMToken = (token) => {
    navigator.clipboard.writeText(token).then(() => {
      setCopiedToken(token);
      toast.success('FCM Token copied to clipboard!');
      setTimeout(() => setCopiedToken(null), 2000);
    }).catch(err => {
      console.error('Failed to copy token: ', err);
      toast.error('Failed to copy token');
    });
  };

  // Activate/Update custom plan
  const activateCustomPlan = async () => {
    try {
      if (!selectedUserId || !customDate) {
        toast.error('Please select a date');
        return;
      }

      toast.loading('Updating premium plan...', { id: 'activate' });

      const userRef = doc(db, 'users', selectedUserId);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data();

      // Create custom expiry date
      const expiryDate = new Date(`${customDate}T${customTime}`);
      
      // Calculate days difference
      const today = new Date();
      const diffTime = expiryDate - today;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      const diffMonths = Math.floor(diffDays / 30);
      const remainingDays = diffDays % 30;

      let durationText = '';
      if (diffMonths > 0) {
        durationText = `${diffMonths} month${diffMonths > 1 ? 's' : ''}`;
        if (remainingDays > 0) {
          durationText += ` ${remainingDays} day${remainingDays > 1 ? 's' : ''}`;
        }
      } else {
        durationText = `${diffDays} day${diffDays > 1 ? 's' : ''}`;
      }

      const isUpdating = userData.planType === 'premium';
      const action = isUpdating ? 'updated' : 'activated';
      const planName = diffDays <= 0 ? 'Free' : `Custom Premium (${durationText})`;

      // Update user document
      await updateDoc(userRef, {
        planType: diffDays <= 0 ? 'free' : 'premium',
        activePlan: diffDays <= 0 ? 'free' : 'custom_premium',
        planName: planName,
        premiumUntil: diffDays <= 0 ? null : Timestamp.fromDate(expiryDate),
        updatedAt: Timestamp.now(),
        lastPlanActivation: Timestamp.now(),
        customPlanActivated: diffDays > 0,
        customPlanDuration: diffDays > 0 ? durationText : null,
        customPlanExpiry: diffDays > 0 ? expiryDate.toISOString() : null
      });

      // Add to activation history (stored in user document itself)
      const historyEntry = {
        planId: diffDays <= 0 ? 'free' : 'custom_premium',
        planName: diffDays <= 0 ? 'Free Plan' : 'Custom Premium Plan',
        planType: diffDays <= 0 ? 'free' : 'premium',
        activatedAt: Timestamp.now(),
        expiresAt: diffDays <= 0 ? null : Timestamp.fromDate(expiryDate),
        duration: durationText,
        activatedBy: 'admin',
        userEmail: userData.email,
        customActivation: true,
        expiryDate: diffDays <= 0 ? null : expiryDate.toISOString(),
        totalDays: diffDays,
        action: isUpdating ? 'updated' : 'activated'
      };

      // Update history in user document
      const currentHistory = userData.activationHistory || [];
      await updateDoc(userRef, {
        activationHistory: [...currentHistory, historyEntry]
      });

      toast.success(`Premium plan ${action} until ${formatFirestoreDate(Timestamp.fromDate(expiryDate))}`, {
        id: 'activate',
        duration: 5000
      });

      // Close modal and refresh
      setShowPlanModal(false);
      setSelectedUserId(null);
      fetchUsers();

    } catch (error) {
      console.error('Error updating premium plan:', error);
      toast.error(`Failed to update plan: ${error.message}`, {
        id: 'activate'
      });
    }
  };

  // Deactivate premium
  const deactivatePremium = async (userId) => {
    try {
      toast.loading('Deactivating premium...', { id: 'deactivate' });
      
      const userRef = doc(db, 'users', userId);
      const userSnap = await getDoc(userRef);
      const userData = userSnap.data();
      
      await updateDoc(userRef, {
        planType: 'free',
        activePlan: 'free',
        planName: 'Free',
        premiumUntil: null,
        updatedAt: Timestamp.now(),
        premiumDeactivatedAt: Timestamp.now(),
        customPlanActivated: false,
        customPlanDuration: null,
        customPlanExpiry: null
      });

      // Add to history in user document
      const historyEntry = {
        action: 'deactivate',
        previousPlan: userData.activePlan || 'premium',
        deactivatedAt: Timestamp.now(),
        deactivatedBy: 'admin',
        userEmail: userData.email,
        reason: 'Admin deactivated'
      };

      const currentHistory = userData.activationHistory || [];
      await updateDoc(userRef, {
        activationHistory: [...currentHistory, historyEntry]
      });

      toast.success('Premium deactivated successfully!', {
        id: 'deactivate',
        duration: 3000
      });
      
      fetchUsers();
    } catch (error) {
      console.error('Error deactivating premium:', error);
      toast.error(`Error deactivating premium: ${error.message}`, {
        id: 'deactivate'
      });
    }
  };

  // View user details
  const viewUserDetails = (user) => {
    setSelectedUser(user);
    setShowUserModal(true);
  };

  // Logout function
  const handleLogout = async () => {
    try {
      await signOut(auth);
      toast.success('Logged out successfully');
      window.location.href = '/login';
    } catch (error) {
      toast.error('Error logging out');
    }
  };

  // Filter users based on search and filter type
  const filteredUsers = useMemo(() => {
    let filtered = users;
    
    // Apply filter type
    if (filterType === 'premium') {
      filtered = filtered.filter(u => u.planType === 'premium' && u.isPremiumActive);
    } else if (filterType === 'free') {
      filtered = filtered.filter(u => u.planType === 'free');
    } else if (filterType === 'active') {
      filtered = filtered.filter(u => u.status === 'active');
    }
    
    // Apply search term
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(user => 
        (user.email && user.email.toLowerCase().includes(searchLower)) ||
        (user.displayName && user.displayName.toLowerCase().includes(searchLower)) ||
        (user.uid && user.uid.toLowerCase().includes(searchLower)) ||
        (user.phone && user.phone.includes(searchTerm)) ||
        (user.city && user.city.toLowerCase().includes(searchLower)) ||
        (user.country && user.country.toLowerCase().includes(searchLower))
      );
    }
    
    return filtered;
  }, [users, searchTerm, filterType]);

  // Get user stats
  const userStats = useMemo(() => {
    const total = users.length;
    const premium = users.filter(u => u.planType === 'premium' && u.isPremiumActive).length;
    const free = users.filter(u => u.planType === 'free').length;
    const active = users.filter(u => u.status === 'active').length;
    
    return { total, premium, free, active };
  }, [users]);

  if (loading) {
    return (
      <div className="admin-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading {activeCollection}...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            borderRadius: '10px',
            padding: '16px'
          },
        }}
      />
      
      {/* Header */}
      <header className="admin-header">
        <div className="header-left">
          <h1>🚀 Admin Dashboard</h1>
          <div className="collection-selector">
            <select 
              value={activeCollection}
              onChange={(e) => setActiveCollection(e.target.value)}
              className="collection-select"
            >
              <option value="users">👥 Users</option>
            </select>
          </div>
        </div>
        
        <div className="header-right">
          <div className="user-info">
            <span className="admin-email">{auth.currentUser?.email}</span>
            <button onClick={handleLogout} className="btn-logout">
              🔓 Logout
            </button>
          </div>
        </div>
      </header>

      {/* Stats Cards */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">👥</div>
          <div className="stat-content">
            <h3>{userStats.total}</h3>
            <p>Total Users</p>
          </div>
        </div>
        
        <div className="stat-card premium">
          <div className="stat-icon">⭐</div>
          <div className="stat-content">
            <h3>{userStats.premium}</h3>
            <p>Active Premium</p>
          </div>
        </div>
        
        <div className="stat-card free">
          <div className="stat-icon">🎯</div>
          <div className="stat-content">
            <h3>{userStats.free}</h3>
            <p>Free Users</p>
          </div>
        </div>
        
        <div className="stat-card active">
          <div className="stat-icon">✅</div>
          <div className="stat-content">
            <h3>{userStats.active}</h3>
            <p>Active Users</p>
          </div>
        </div>
      </div>

      {/* Search and Filter */}
      <div className="search-section">
        <div className="search-box">
          <input
            type="text"
            placeholder={`Search ${activeCollection}...`}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="btn-search">🔍</button>
        </div>
        
        <div className="filter-tabs">
          <button 
            className={`filter-tab ${filterType === 'all' ? 'active' : ''}`}
            onClick={() => setFilterType('all')}
          >
            All
          </button>
          <button 
            className={`filter-tab ${filterType === 'premium' ? 'active' : ''}`}
            onClick={() => setFilterType('premium')}
          >
            Premium
          </button>
          <button 
            className={`filter-tab ${filterType === 'free' ? 'active' : ''}`}
            onClick={() => setFilterType('free')}
          >
            Free
          </button>
          <button 
            className={`filter-tab ${filterType === 'active' ? 'active' : ''}`}
            onClick={() => setFilterType('active')}
          >
            Active
          </button>
        </div>
      </div>

      {/* Users Table */}
      <div className="table-container">
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>User Info</th>
                <th>Plan Status</th>
                <th>Location</th>
                <th>Device</th>
                <th>Last Login</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredUsers.length === 0 ? (
                <tr>
                  <td colSpan="7" className="no-data">
                    No {activeCollection} found
                  </td>
                </tr>
              ) : (
                filteredUsers.map((user, index) => (
                  <tr key={user.id}>
                    <td>{index + 1}</td>
                    <td className="user-cell">
                      <div className="user-avatar">
                        {user.displayName?.charAt(0) || 'U'}
                      </div>
                      <div className="user-details">
                        <div className="user-name">{user.displayName || 'No Name'}</div>
                        <div className="user-email">{user.email || 'No Email'}</div>
                        <div className="user-meta">
                          <span className="user-id">ID: {user.uid || user.id}</span>
                          <span className="user-phone">{user.phone || 'No Phone'}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="plan-status">
                        <span className={`plan-badge ${user.planType === 'premium' ? 'premium' : 'free'}`}>
                          {user.planType === 'premium' ? '⭐ Premium' : '🎯 Free'}
                        </span>
                        {user.premiumUntil && (
                          <div className="plan-expiry">
                            <small>Expires: {user.formattedPremiumUntil}</small>
                            {user.daysLeftInPremium > 0 && (
                              <small className="days-left">({user.daysLeftInPremium} days left)</small>
                            )}
                          </div>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="location-info">
                        <div className="city">{user.city || 'N/A'}</div>
                        <div className="country">{user.country || 'N/A'}</div>
                      </div>
                    </td>
                    <td>
                      <div className="device-info">
                        <span className={`device-badge ${user.deviceType}`}>
                          {user.deviceType || 'Unknown'}
                        </span>
                        {user.fcmToken && (
                          <small className="fcm-status">FCM Active</small>
                        )}
                      </div>
                    </td>
                    <td>
                      <div className="login-info">
                        {user.formattedLastLogin}
                        {user.emailVerified && (
                          <span className="verified-badge">✓ Verified</span>
                        )}
                      </div>
                    </td>
                    <td className="actions-cell">
                      <div className="action-buttons">
                        <button 
                          className="btn-action view"
                          onClick={() => viewUserDetails(user)}
                          title="View Details"
                        >
                          👁️
                        </button>
                        
                        <button 
                          className="btn-action edit"
                          onClick={() => openPlanModal(user.id)}
                          title={user.planType === 'premium' ? "Edit Plan" : "Activate Premium"}
                        >
                          {user.planType === 'premium' ? '✏️' : '⭐'}
                        </button>
                        
                        {user.planType === 'premium' && (
                          <button 
                            className="btn-action deactivate"
                            onClick={() => deactivatePremium(user.id)}
                            title="Deactivate Premium"
                          >
                            ❌
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Plan Activation Modal */}
      {showPlanModal && (
        <div className="modal-overlay">
          <div className="modal">
            <div className="modal-header">
              <h3>{users.find(u => u.id === selectedUserId)?.planType === 'premium' ? 'Edit Premium Plan' : 'Activate Premium Plan'}</h3>
              <button 
                className="modal-close"
                onClick={() => setShowPlanModal(false)}
              >
                ✕
              </button>
            </div>
            
            <div className="modal-body">
              <div className="form-group">
                <label>Select Expiry Date</label>
                <input
                  type="date"
                  value={customDate}
                  onChange={(e) => setCustomDate(e.target.value)}
                  className="form-input"
                  min={new Date().toISOString().split('T')[0]}
                />
              </div>
              
              <div className="form-group">
                <label>Select Expiry Time</label>
                <input
                  type="time"
                  value={customTime}
                  onChange={(e) => setCustomTime(e.target.value)}
                  className="form-input"
                />
              </div>
              
              {customDate && (
                <div className="plan-preview">
                  <h4>Plan Details:</h4>
                  <div className="preview-item">
                    <span>Plan Type:</span>
                    <strong>Custom Premium</strong>
                  </div>
                  <div className="preview-item">
                    <span>Expiry:</span>
                    <strong>{new Date(`${customDate}T${customTime}`).toLocaleString()}</strong>
                  </div>
                  <div className="preview-item">
                    <span>Duration:</span>
                    <strong>
                      {(() => {
                        const expiryDate = new Date(`${customDate}T${customTime}`);
                        const today = new Date();
                        const diffDays = Math.ceil((expiryDate - today) / (1000 * 60 * 60 * 24));
                        const months = Math.floor(diffDays / 30);
                        const days = diffDays % 30;
                        
                        if (months > 0) {
                          return `${months} month${months > 1 ? 's' : ''} ${days > 0 ? `${days} day${days > 1 ? 's' : ''}` : ''}`;
                        }
                        return `${diffDays} day${diffDays > 1 ? 's' : ''}`;
                      })()}
                    </strong>
                  </div>
                </div>
              )}
            </div>
            
            <div className="modal-footer">
              <button 
                className="btn btn-secondary"
                onClick={() => setShowPlanModal(false)}
              >
                Cancel
              </button>
              <button 
                className="btn btn-primary"
                onClick={activateCustomPlan}
                disabled={!customDate}
              >
                {users.find(u => u.id === selectedUserId)?.planType === 'premium' ? '✅ Update Plan' : '✅ Activate Plan'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* User Details Modal */}
      {showUserModal && selectedUser && (
        <div className="modal-overlay">
          <div className="modal user-modal">
            <div className="modal-header">
              <h3>User Details</h3>
              <button 
                className="modal-close"
                onClick={() => setShowUserModal(false)}
              >
                ✕
              </button>
            </div>
            
            <div className="modal-body">
              {/* User Profile Section */}
              <div className="user-profile-section">
                <div className="profile-avatar-large">
                  {selectedUser.name?.charAt(0) || 'U'}
                </div>
                <div className="profile-info">
                  <h4>{selectedUser.name || 'No Name'}</h4>
                  <p className="profile-email">{selectedUser.email || 'No Email'}</p>
                  <div className="profile-meta">
                    <span className="meta-badge uid">ID: {selectedUser.uid || selectedUser.id}</span>
                    <span className="meta-badge phone">📱 {selectedUser.phone || 'No Phone'}</span>
                    <span className={`meta-badge ${selectedUser.status}`}>
                      {selectedUser.status || 'unknown'}
                    </span>
                  </div>
                </div>
              </div>

              {/* User Details Grid */}
              <div className="details-grid">
                {/* Account Details */}
                <div className="detail-section">
                  <h5>Account Details</h5>
                  <div className="detail-row">
                    <span>Account Type:</span>
                    <strong>{selectedUser.accountType || 'user'}</strong>
                  </div>
                  <div className="detail-row">
                    <span>User Type:</span>
                    <strong>{selectedUser.userType || 'regular'}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Role:</span>
                    <strong>{selectedUser.role || 'user'}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Email Verified:</span>
                    <strong className={selectedUser.emailVerified ? 'verified' : 'not-verified'}>
                      {selectedUser.emailVerified ? '✅ Yes' : '❌ No'}
                    </strong>
                  </div>
                  <div className="detail-row">
                    <span>Profile Complete:</span>
                    <strong className={selectedUser.profileComplete ? 'yes' : 'no'}>
                      {selectedUser.profileComplete ? '✅ Yes' : '❌ No'}
                    </strong>
                  </div>
                </div>

                {/* Plan Details */}
                <div className="detail-section">
                  <h5>Plan Details</h5>
                  <div className="detail-row">
                    <span>Current Plan:</span>
                    <strong className={`plan-tag ${selectedUser.planType}`}>
                      {selectedUser.planName || selectedUser.planType}
                    </strong>
                  </div>
                  <div className="detail-row">
                    <span>Plan Type:</span>
                    <strong>{selectedUser.planType || 'free'}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Active Plan:</span>
                    <strong>{selectedUser.activePlan || 'free'}</strong>
                  </div>
                  {selectedUser.premiumUntil && (
                    <>
                      <div className="detail-row">
                        <span>Premium Until:</span>
                        <strong>{selectedUser.formattedPremiumUntil}</strong>
                      </div>
                      {selectedUser.daysLeftInPremium > 0 && (
                        <div className="detail-row">
                          <span>Days Left:</span>
                          <strong className="days-left">{selectedUser.daysLeftInPremium} days</strong>
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Location & Device */}
                <div className="detail-section">
                  <h5>Location & Device</h5>
                  <div className="detail-row">
                    <span>City:</span>
                    <strong>{selectedUser.city || 'N/A'}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Country:</span>
                    <strong>{selectedUser.country || 'N/A'}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Device Type:</span>
                    <strong className={`device ${selectedUser.deviceType}`}>
                      {selectedUser.deviceType || 'Unknown'}
                    </strong>
                  </div>
                </div>

                {/* FCM Token Section */}
                {selectedUser.fcmToken && (
                  <div className="detail-section">
                    <h5>FCM Token</h5>
                    <div className="fcm-token-container">
                      <div className="fcm-token-display">
                        <code>{selectedUser.fcmToken}</code>
                      </div>
                      <button 
                        className="btn-copy-token"
                        onClick={() => copyFCMToken(selectedUser.fcmToken)}
                      >
                        {copiedToken === selectedUser.fcmToken ? '✅ Copied!' : '📋 Copy'}
                      </button>
                    </div>
                  </div>
                )}

                {/* Timestamps */}
                <div className="detail-section">
                  <h5>Timestamps</h5>
                  <div className="detail-row">
                    <span>Created At:</span>
                    <strong>{selectedUser.formattedCreatedAt}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Last Updated:</span>
                    <strong>{selectedUser.formattedUpdatedAt}</strong>
                  </div>
                  <div className="detail-row">
                    <span>Last Login:</span>
                    <strong>{selectedUser.formattedLastLogin}</strong>
                  </div>
                  {selectedUser.lastPlanActivation && (
                    <div className="detail-row">
                      <span>Last Plan Activation:</span>
                      <strong>{selectedUser.formattedLastPlanActivation}</strong>
                    </div>
                  )}
                  {selectedUser.premiumActivatedAt && (
                    <div className="detail-row">
                      <span>Premium Activated At:</span>
                      <strong>{formatFirestoreDate(selectedUser.premiumActivatedAt)}</strong>
                    </div>
                  )}
                  {selectedUser.premiumDeactivatedAt && (
                    <div className="detail-row">
                      <span>Premium Deactivated At:</span>
                      <strong>{formatFirestoreDate(selectedUser.premiumDeactivatedAt)}</strong>
                    </div>
                  )}
                </div>
              </div>

              {/* Activation History */}
              {selectedUser.activationHistory && selectedUser.activationHistory.length > 0 && (
                <div className="history-section">
                  <h5>Activation History ({selectedUser.activationHistory.length})</h5>
                  <div className="history-list">
                    {selectedUser.activationHistory.slice(-10).reverse().map((entry, idx) => (
                      <div key={idx} className="history-item">
                        <div className="history-plan">{entry.planName || entry.action || 'Plan Change'}</div>
                        <div className="history-date">
                          {entry.activatedAt ? formatFirestoreDate(entry.activatedAt) : 
                           entry.deactivatedAt ? formatFirestoreDate(entry.deactivatedAt) : 'N/A'}
                        </div>
                        <div className="history-duration">{entry.duration || 'N/A'}</div>
                        <div className="history-by">{entry.activatedBy || entry.deactivatedBy || 'Admin'}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            
            <div className="modal-footer">
              <button 
                className="btn btn-secondary"
                onClick={() => setShowUserModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Footer Actions */}
      <div className="footer-actions">
        <button onClick={fetchUsers} className="btn-refresh">
          🔄 Refresh Data
        </button>
        <div className="stats-info">
          Showing {filteredUsers.length} of {users.length} {activeCollection}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;